import { WidgetTile } from 'components/widgets/tile/tile';
import styled from 'styled-components';

export const StyledWidgetTile = styled(WidgetTile)`
  grid-area: carOverviewBottomWidget;
  height: 100%;
`;
